const getFormData = state => state?.formData?.formData

const selectors={
    getFormData,
}

export default selectors;